export const portalRecoveryTranslations = {
  de: {
    code: 'Fehlercode',
    request: 'Request-Referenz',
    tracking: 'Fehlerreferenz',
    attempt: 'Versuch',
    page: 'Seite',
    message: 'Meldungsschlüssel',
    target: 'Datensatz',
    orderFailed: 'Portalbestellung fehlgeschlagen',
    changedCount: 'Bei {{count}} Positionen haben sich Preise geändert.',
    changed: 'Preise geändert',
    reviewPrices: 'Prüfen Sie die bisherigen und neuen Preise sowie die Gesamtsumme.',
    oldPrice: 'Bisheriger Stückpreis / Rabatt',
    newPrice: 'Aktueller Stückpreis / Rabatt',
    newTotal: 'Aktuelle Gesamtsumme',
    acceptPrices: 'Ich habe die aktualisierten Preise geprüft und bestätige sie.',
    portal: 'Kundenportal',
    failed: 'Portalaktion fehlgeschlagen',
    displayed: 'Dem Kunden angezeigte Meldung',
    server: 'Servernachweis',
    browser: 'Browsermeldung',
    details: 'Technische Details',
    action: 'Aktion',
    outcome: 'Ergebnis',
    reference: 'Vorgangsreferenz',
    empty: 'Noch keine Portalaktivitäten vorhanden.',
    error: 'Portalaktivitäten konnten nicht geladen werden.',
    pricePending: 'Bei diesem Versuch waren die neuen Preise noch nicht bestätigt.',
    linked: 'Verknüpften Datensatz öffnen',
    previous: 'Zurück',
    next: 'Weiter',
    unknown: 'Unbekannt',
    success: 'Erfolgreich',
    scope: 'Portalvorgänge zählen nicht als persönlicher Vertriebskontakt.',
  },
  en: {
    code: 'Error code',
    request: 'Request reference',
    tracking: 'Error reference',
    attempt: 'Attempt',
    page: 'Page',
    message: 'Message key',
    target: 'Record',
    orderFailed: 'Portal order failed',
    changedCount: 'Prices changed for {{count}} items.',
    changed: 'Prices changed',
    reviewPrices: 'Review the previous and current prices and the total.',
    oldPrice: 'Previous unit price / discount',
    newPrice: 'Current unit price / discount',
    newTotal: 'Current total',
    acceptPrices: 'I have reviewed and confirm the updated prices.',
    portal: 'Customer portal',
    failed: 'Portal action failed',
    displayed: 'Message shown to the customer',
    server: 'Server evidence',
    browser: 'Browser report',
    details: 'Technical details',
    action: 'Action',
    outcome: 'Outcome',
    reference: 'Operation reference',
    empty: 'No portal activity yet.',
    error: 'Portal activity could not be loaded.',
    pricePending: 'Updated prices had not yet been confirmed in this attempt.',
    linked: 'Open linked record',
    previous: 'Previous',
    next: 'Next',
    unknown: 'Unknown',
    success: 'Successful',
    scope: 'Portal activity does not count as a personal sales contact.',
  },
  fr: {
    code: 'Code d’erreur',
    request: 'Référence de requête',
    tracking: 'Référence d’erreur',
    attempt: 'Tentative',
    page: 'Page',
    message: 'Clé du message',
    target: 'Enregistrement',
    orderFailed: 'Échec de la commande du portail',
    changedCount: 'Les prix de {{count}} articles ont changé.',
    changed: 'Prix modifiés',
    reviewPrices: 'Vérifiez les anciens et nouveaux prix ainsi que le total.',
    oldPrice: 'Ancien prix unitaire / remise',
    newPrice: 'Prix unitaire actuel / remise',
    newTotal: 'Total actuel',
    acceptPrices: 'J’ai vérifié et je confirme les prix actualisés.',
    portal: 'Portail client',
    failed: 'Échec de l’action du portail',
    displayed: 'Message affiché au client',
    server: 'Preuve serveur',
    browser: 'Signalement du navigateur',
    details: 'Détails techniques',
    action: 'Action',
    outcome: 'Résultat',
    reference: 'Référence de l’opération',
    empty: 'Aucune activité du portail.',
    error: 'Impossible de charger les activités du portail.',
    pricePending: 'Les prix actualisés n’avaient pas encore été confirmés lors de cette tentative.',
    linked: 'Ouvrir l’enregistrement lié',
    previous: 'Précédent',
    next: 'Suivant',
    unknown: 'Inconnu',
    success: 'Réussi',
    scope: 'Les activités du portail ne comptent pas comme contacts commerciaux personnels.',
  },
  es: {
    code: 'Código de error',
    request: 'Referencia de solicitud',
    tracking: 'Referencia de error',
    attempt: 'Intento',
    page: 'Página',
    message: 'Clave del mensaje',
    target: 'Registro',
    orderFailed: 'Pedido del portal fallido',
    changedCount: 'Han cambiado los precios de {{count}} posiciones.',
    changed: 'Precios modificados',
    reviewPrices: 'Revise los precios anteriores y actuales y el total.',
    oldPrice: 'Precio unitario anterior / descuento',
    newPrice: 'Precio unitario actual / descuento',
    newTotal: 'Total actual',
    acceptPrices: 'He revisado y confirmo los precios actualizados.',
    portal: 'Portal de clientes',
    failed: 'Acción del portal fallida',
    displayed: 'Mensaje mostrado al cliente',
    server: 'Evidencia del servidor',
    browser: 'Informe del navegador',
    details: 'Detalles técnicos',
    action: 'Acción',
    outcome: 'Resultado',
    reference: 'Referencia de la operación',
    empty: 'Todavía no hay actividad del portal.',
    error: 'No se pudo cargar la actividad del portal.',
    pricePending: 'Los precios actualizados aún no se habían confirmado en este intento.',
    linked: 'Abrir registro vinculado',
    previous: 'Anterior',
    next: 'Siguiente',
    unknown: 'Desconocido',
    success: 'Correcto',
    scope: 'La actividad del portal no cuenta como contacto comercial personal.',
  },
  tr: {
    code: 'Hata kodu',
    request: 'İstek referansı',
    tracking: 'Hata referansı',
    attempt: 'Deneme',
    page: 'Sayfa',
    message: 'Mesaj anahtarı',
    target: 'Kayıt',
    orderFailed: 'Portal siparişi başarısız',
    changedCount: '{{count}} kalemin fiyatı değişti.',
    changed: 'Fiyatlar değişti',
    reviewPrices: 'Önceki ve güncel fiyatları ve toplamı inceleyin.',
    oldPrice: 'Önceki birim fiyat / indirim',
    newPrice: 'Güncel birim fiyat / indirim',
    newTotal: 'Güncel toplam',
    acceptPrices: 'Güncel fiyatları inceledim ve onaylıyorum.',
    portal: 'Müşteri portalı',
    failed: 'Portal işlemi başarısız',
    displayed: 'Müşteriye gösterilen mesaj',
    server: 'Sunucu kaydı',
    browser: 'Tarayıcı bildirimi',
    details: 'Teknik ayrıntılar',
    action: 'İşlem',
    outcome: 'Sonuç',
    reference: 'İşlem referansı',
    empty: 'Henüz portal etkinliği yok.',
    error: 'Portal etkinlikleri yüklenemedi.',
    pricePending: 'Bu denemede güncel fiyatlar henüz onaylanmamıştı.',
    linked: 'Bağlantılı kaydı aç',
    previous: 'Önceki',
    next: 'Sonraki',
    unknown: 'Bilinmiyor',
    success: 'Başarılı',
    scope: 'Portal işlemleri kişisel satış teması sayılmaz.',
  },
} as const;
